import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Container } from "@mui/material";
import dayjs from "dayjs";
import Paper from "@mui/material/Paper";

import TableContainer from "@mui/material/TableContainer";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";

import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import SubTitle from "../../components/SubTitle";
import {
  StripedTableCell,
  StripedTableRow,
  StripedTableHeadCell,
} from "../../components/StripedTable";

import { doService } from "../../services/ServiceHelper";
import {
  extGetCommServiceOp,
  extUpdateCommServiceOp,
} from "../../services/CommServiceService";

import {
  getFirstSchool,
  getSchoolBySubdomain,
} from "../../services/SchoolService";
import { getSubDomain } from "../../services/StringService";
import { showError, showSuccess } from "../../components/ATPDialogs";

const VerifyOp = () => {
  const [_school, setSchool] = useState(false);
  const [_showProgress, setShowProgress] = useState(false);
  const [_searchPerformed, setSearchPerformed] = useState(false);

  const [_result, setResult] = useState([]);
  const { eid } = useParams();

  useEffect(() => {
    const subdomain = getSubDomain();
    let school = getSchoolBySubdomain(subdomain);

    if (school == null) {
      school = getFirstSchool();
    }

    setSchool(school);
    initData(school);
  }, []);

  const initData = (school) => {
    setShowProgress(true);
    doService(extGetCommServiceOp(school, eid), (results) => {
      setSearchPerformed(true);
      setResult(results.data);
      setShowProgress(false);
    });
  };

  const handleAccept = () => {
    setShowProgress(true);
    doService(extUpdateCommServiceOp(_school, eid, 100, ""), (results) => {
      setShowProgress(false);

      if (results.data.updated === false) {
        showError("Service Op Not Updated", results.data.message);
      } else {
        showSuccess(
          "Service Op Approved",
          "Thank you for approving this Service Op!  You may now close this window."
        );
      }
    });
  };

  const handleReject = () => {
    const reason = window.prompt("Enter reason for rejecting Service Op.");
    setShowProgress(true);
    doService(extUpdateCommServiceOp(_school, eid, -100, reason), (results) => {
      setShowProgress(false);

      if (results.data.updated === false) {
        showError("Service Op Not Updated", results.data.message);
      } else {
        showSuccess(
          "Service Op",
          "Thank you for for your input!  You may now close this window."
        );
      }
    });
  };

  return (
    <>
      <DrawerAppBar showHamburger={false} showLogout={false} />

      <Container sx={{ mt: 1 }}>
        <Title text="Verify Community Service Op" showBack={false} />
        <ProgressBar showProgress={_showProgress} />

        <Alert severity="info" sx={{ pb: 0, mt: 1 }}>
          Please review the details of the student's community service
          opportunity below, and click either the Accept or Reject buttons
          below. Thank you.
        </Alert>

        {_searchPerformed && (
          <>
            <Box sx={{ boxShadow: 1, p: 1, mt: 1 }}>
              <SubTitle text="Student Summary" />
              <TableContainer component={Paper} sx={{ mt: 0 }}>
                <Table sx={{ width: "100%" }} size="small">
                  <TableBody>
                    <StripedTableRow>
                      <StripedTableHeadCell>First Name</StripedTableHeadCell>
                      <StripedTableCell>
                        {_result.studentFirstName}
                      </StripedTableCell>
                    </StripedTableRow>
                    <StripedTableRow>
                      <StripedTableHeadCell>Last Name</StripedTableHeadCell>
                      <StripedTableCell>
                        {_result.studentLastName}
                      </StripedTableCell>
                    </StripedTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Box sx={{ boxShadow: 1, p: 1, mt: 1 }}>
              <SubTitle text="Service Op Details  " />

              <TableContainer component={Paper} sx={{ mt: 0 }}>
                <Table sx={{ width: "100%" }} size="small">
                  <TableBody>
                    <StripedTableRow>
                      <StripedTableHeadCell>
                        Date of Service
                      </StripedTableHeadCell>
                      <StripedTableCell>
                        {dayjs(_result.eventDate).format("MM/DD/YY")}
                      </StripedTableCell>
                    </StripedTableRow>
                    <StripedTableRow>
                      <StripedTableHeadCell>Service Type</StripedTableHeadCell>
                      <StripedTableCell>{_result.typeName}</StripedTableCell>
                    </StripedTableRow>
                    <StripedTableRow>
                      <StripedTableHeadCell>Description</StripedTableHeadCell>
                      <StripedTableCell>{_result.description}</StripedTableCell>
                    </StripedTableRow>
                    <StripedTableRow>
                      <StripedTableHeadCell>
                        Hours Performed
                      </StripedTableHeadCell>
                      <StripedTableCell>{_result.hourNum}</StripedTableCell>
                    </StripedTableRow>
                    <StripedTableRow>
                      <StripedTableHeadCell>
                        Minutes Performed
                      </StripedTableHeadCell>
                      <StripedTableCell>{_result.minuteNum}</StripedTableCell>
                    </StripedTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {_result.verifierStatus === 0 && (
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  {" "}
                  <Button
                    sx={{ mt: 1 }}
                    variant="contained"
                    color="success"
                    fullWidth
                    onClick={handleAccept}
                  >
                    Accept
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  {" "}
                  <Button
                    sx={{ mt: 1 }}
                    variant="contained"
                    color="error"
                    fullWidth
                    onClick={handleReject}
                  >
                    Reject
                  </Button>
                </Grid>
              </Grid>
            )}

            {_result.verifierStatus === 100 && (
              <h2>You have accepted this student's Service Op. Thank you.</h2>
            )}
            {_result.verifierStatus === -100 && (
              <h2>You have rejected this student's Service Op. Thank you.</h2>
            )}
          </>
        )}
      </Container>
    </>
  );
};

export default VerifyOp;
